import * as Sentry from '@sentry/vue';
import { version } from '../../package.json';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export interface SentrySetupOptions {
  router: Router;
  config: any;
}

export function SentrySetup(app: App<Element>, { router, config }: SentrySetupOptions) {
  Sentry.init({
    app,
    dsn: 'https://8e1b8bbda297187c8230b8a00ff0fa02@sentry.mntr-agent.net/9',
    release: `${config.selectedTheme}@${version}`,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    denyUrls: [],
    // Tracing
    // tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/api\..*/],
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // replaysOnErrorSampleRate: 0,
  });
}
